import { AppState } from "../reducer";
import { createSelector } from "reselect";
import { openLeagues } from "../leagues/selectors";
import { LOADING, NOT_STARTED, dataOf } from "../../framework/data";
import { MatchHeader } from "./models";
import { LeagueHeader } from "../leagues/models";

export const currentSeasonNewestMatches = (state : AppState) => state.matches.currentSeasonNewestMatches;

export const currentSeasonNewestMatchesWithLeagues = createSelector(currentSeasonNewestMatches, openLeagues, (matches, leagues) => {

    if(matches.type === "FAILED") {
        return matches;
    }

    if(leagues.type === "FAILED") {
        return leagues;
    }

    if(leagues.type === "LOADING" || matches.type === "LOADING") {
        return LOADING;
    }

    if(leagues.type === "NOT_STARTED" || matches.type === "NOT_STARTED") {
        return NOT_STARTED;
    }

    if(leagues.type === "LOADED" && matches.type === "LOADED") {

        const results: MatchHeaderWithLeagueInfo[] = matches.value.map(m => ({...m, league: leagues.value.find(l => l.id === m.league) }));

        return dataOf(results);

    }

    return NOT_STARTED;

});

export type MatchHeaderWithLeagueInfo = Omit<MatchHeader, "league"> & {league?: LeagueHeader};